<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.00146 10.9992L8.21246 11.1052C8.76792 11.3829 9.38042 11.5275 10.0015 11.5275C10.6225 11.5275 11.235 11.3829 11.7905 11.1052L12.0015 10.9992M3 5.99938H17C18.1046 5.99938 19 6.89481 19 7.99938V15.9994C19 17.1039 18.1046 17.9994 17 17.9994H3C1.89543 17.9994 1 17.1039 1 15.9994V7.99938C1 6.89481 1.89543 5.99938 3 5.99938ZM6.99875 5C6.99875 4.46957 7.20947 3.96086 7.58454 3.58579C7.95961 3.21071 8.46832 3 8.99875 3H10.9988C11.5292 3 12.0379 3.21071 12.413 3.58579C12.788 3.96086 12.9988 4.46957 12.9988 5V6H6.99875V5Z"
      stroke="#F57E53"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
